import { AuditLog } from "@myapp/contract";
import { useQuery } from "@tanstack/react-query";
import { auditLogKeys } from "../audit-log.keys";
import { auditLogApi } from "../service";

export function useAuditLogByWorkOrder(workOrderId: string | undefined) {
  return useQuery({
    queryKey: auditLogKeys.byWorkOrder(workOrderId ?? ''),
    queryFn: async () => {
      const { data } = await auditLogApi.listByWorkOrder(workOrderId!);
      return data as AuditLog[];
    },
    enabled: Boolean(workOrderId),
    placeholderData: (prev) => prev,
  });
}
